export default __webpack_public_path__ + "static/media/close.fa7e5ead.svg";